/* istanbul ignore file */
export enum Status {
  GENERAL = 'general',
  DRAFT = 'draft',
  PUBLISHED = 'published',
  ARCHIVED = 'archived',
  DELETED = 'deleted',
  IMPORTED = 'imported',
}
